// AUTO-GENERATED GraphQL Builder for LoginResult
import * as Builders from '../';
export class LoginResultBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  accessToken(){ return this.add('accessToken'); }
  accessTokenExpiresAt(){ return this.add('accessTokenExpiresAt'); }
  persona(){ return this.add('persona'); }
  roles(){ return this.add('roles'); }
  vendorId(){ return this.add('vendorId'); }
  customerId(){ return this.add('customerId'); }

  user(b?:(q:Builders.AuthUserBuilder)=>void){
    if(this.depth>=5||this.v.has('user'))return this;
    this.v.add('user');
    const n=new Builders.AuthUserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`user { ${inner} }`);
    return this;
  }
}
